import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createRef } from 'react';
import ContactUsComponent from "./ContactUs.component";
import DataContainer from 'Util/Request/DataContainer';
import {fetchMutation} from 'Util/Request';
import { showNotification } from 'Store/Notification/Notification.action';
import { updateMeta } from 'Store/Meta/Meta.action';
import { goToPreviousNavigationState } from 'Store/Navigation/Navigation.action';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import ContactUsFormQuery from '../../query/ContactUsForm.query'

const recaptchaRef = createRef();

/** @namespace Route/ContactUs/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    contact_us_recipients : state.ConfigReducer.contact_us_recipients,
    recaptcha_public_key : state.ConfigReducer.recaptcha_public_key,
    countries : state.ConfigReducer.countries,
    recaptcha_frontend_enabled : state.ConfigReducer.recaptcha_frontend_enabled,
    recaptcha_frontend_enabled_contact : state.ConfigReducer.recaptcha_frontend_enabled_contact
});

/** @namespace Route/ContactUs/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    updateMeta: (meta) => dispatch(updateMeta(meta)),
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    goToPreviousNavigationState: (state) => dispatch(goToPreviousNavigationState(TOP_NAVIGATION_TYPE, state)),
    showNotification: (type, message) => dispatch(showNotification(type, message))
});

/** @namespace Route/ContactUs/Container */
export class ContactUsContainer extends DataContainer {
    static propTypes = {
        hideActiveOverlay: PropTypes.func.isRequired,
        goToPreviousNavigationState: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired
    };

    state = {
        firstname : '',
        lastname : '',
        email : '',
        telephone : '',
        message : '',
        country : '',
        captchaValidation : null,
        isCaptchaValidated : false,
        countriesFormatted : [],
        contactUsRecipientsFormatted : [],
        isLoading : false,
        // neccessary for custom telephone field to work
        isSubmitted : false
    }

    requriedFields = [
        'firstname',
        'lastname',
        'email',
        'telephone',
        'recipient_code',
        'message'
    ];

    componentDidMount(){
        const { updateMeta, contact_us_recipients, countries } = this.props;
        updateMeta({ title: __('Contact Us'), canonical_url : window.location.href  });
        const { contactUsRecipientsFormatted, countriesFormatted } = this.state;
        if(contact_us_recipients && Object.keys(contact_us_recipients).length && !contactUsRecipientsFormatted.length){
            this.setState({
                contactUsRecipientsFormatted: Object.keys(contact_us_recipients).map((key) => {
                    return {
                        id:key,
                        label:contact_us_recipients[key].recipient_title,
                        value:contact_us_recipients[key].recipient_code
                    };
                })
            });
        }
        // if(countries && Object.keys(countries).length && !countriesFormatted.length){
        //     let formatted = [];
        //     Object.keys(countries).map((keyStr, key) => {
        //         formatted.push( {
        //             id:key,
        //             label:countries[key].label,
        //             value:countries[key].label
        //         });
        //     });
        //     formatted.push({id: formatted.length,label: __("Other"),value: __("Other")});
        //     this.setState({
        //         countriesFormatted: formatted
        //     });
        // }
    }

    containerFunctions = {
        onFormSubmit : this.onFormSubmit.bind(this),
        onFormSubmitSuccess : this.onFormSubmitSuccess.bind(this),
        onFormSubmitFailure : this.onFormSubmitFailure.bind(this),
        setCaptchaValidation : this.setCaptchaValidation.bind(this),
    };
    onFormSubmit(){
    }

    hidePopUp () {
        const { hideActiveOverlay, goToPreviousNavigationState } = this.props;
        hideActiveOverlay();
        goToPreviousNavigationState();
    };

    setCaptchaValidation(value){
        this.setState({ captchaValidation : value, isCaptchaValidated : true});
    }

    onFormSubmitSuccess(fields){
        const { showNotification, recaptcha_frontend_enabled, recaptcha_frontend_enabled_contact, popupClose } = this.props;
        const { isCaptchaValidated } = this.state;

        let intersection = Object.keys(fields).filter(x => this.requriedFields.includes(x));
        if(intersection.length !== this.requriedFields.length ){
            return;
        }

        if(!isCaptchaValidated && recaptcha_frontend_enabled && recaptcha_frontend_enabled_contact){
            showNotification('warning', __('Please validate captcha challenge'));
            return false;
        }

        let newfields = {...fields};
        newfields.captchaValidation = this.state.captchaValidation;
        newfields.fullname = newfields.firstname + ' ' + newfields.lastname;
        newfields.save = true;
        let state = {...newfields};
        state.isLoading = true;
        this.setState(state);
        const mutation = ContactUsFormQuery.getContactUsFormQuery(newfields);
        return fetchMutation(mutation).then(
            ({ contactusFormSubmit : { success_message } }) => {
                showNotification('success', success_message);
                if(window.grecaptcha)
                    window.grecaptcha.reset();
                this.resetFieldsWithoutState();
                this.setState({
                    isCaptchaValidated : false,
                    isLoading : false
                });
                if(popupClose)
                    this.hidePopUp();
            },
            error => {
                if(error[0].debugMessage){
                    showNotification('error', error[0].debugMessage)
                }else {
                    showNotification('error', error[0].message)
                }
                if(window.grecaptcha)
                    window.grecaptcha.reset();

                this.setState({...fields,isLoading : false, isCaptchaValidated : false});
            }
        );
    }

    onFormSubmitFailure(fields){
        this.setState({ isSubmitted: true });
    }


    resetFieldsWithoutState(){
        const form = document.querySelector('#mageguide-contact-us form');
        if(form){
            const inputFields = form.getElementsByTagName("input");
            setTimeout(()=>{
                for (let i = 0; i < inputFields.length; i++) {
                    inputFields[i].value = '';
                }
                form.getElementsByTagName("textarea")[0].value = '';
            },1000);
        }
    }

    render() {
        return(
            <ContactUsComponent
                { ...this.props }
                { ...this.state }
                { ...this.containerFunctions }
                recaptchaRef={recaptchaRef}
            />
        );
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ContactUsContainer);

